export default __webpack_public_path__ + "static/media/logo_jpg_alta.8207decd.png";